<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增试卷
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="aim"
          slot-scope="text, record"
        >
          <div class="aim-ellipsis">
            {{ record.aim }}
          </div>
        </template>
        <template
          slot="jump_url"
          slot-scope="text, record"
        >
          <a @click="()=>handleChange(record)">查看</a>
        </template>
        <template
          slot="question"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => handleLook(record)"
          >查看</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <product-modal
      ref="formRef"
      :product-visible="productVisible"
      :title="title"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </product-modal>
    <details-modal
      :visible="visibleDetails"
      :src="detailUrl"
      @onCancel="onCancelDetail"
    >
      <form-button
        :show-msg="false"
        submit-text="确定"
        @onCancel="onCancelDetail"
        @onSubmit="onCancelDetail"
      />
    </details-modal>
  </div>
</template>
<script>
import { columns } from './data/index';
import ProductModal from './modal/index.vue';
import DetailsModal from './modal/detailsModal.vue';
export default {
  components: { ProductModal, DetailsModal },
  data() {
    return {
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      productVisible: false,
      title: '',
      paperId: undefined,
      btnIsLoading: false,
      paperData: [{
        key: 1, name: '线上拜访',
      },
      {
        key: 2, name: '学术调研',
      },
      {
        key: 3, name: '科室会通知',
      }, {
        key: 4, name: '沙龙会',
      }, { key: 5, name: '科室会邀请讲课' } ],
      visibleDetails: false,
      detailUrl: '',
    };
  },
  mounted() {

    // 获取表格数据
    this.getTableData({ page: this.current, pageSize: this.pageSize });
  },
  methods: {

    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/paper/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            name: item.name,
            use_type: this.paperData.find((option)=>option.key===item.use_type).name,
            aim: item.aim,
            jump_url: item.jump_url,
			product_info_title: item.product_info.title,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
        console.log(this.data);
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      this.productVisible = true;
      if (!record.id) {
        // 新增
        this.title = '新增试卷';
        this.paperId = '';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        // 编辑
        this.paperId = record.id;
        this.title = '编辑试卷';
        this.$nextTick(() => {
          let data = {
            name: record.name,
            use_type: record.data.use_type,
            aim: record.aim,
			product_id:record.data.product_id,
			company_id:record.data.company_id,
          };
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            let result = await this.$http.post('/paper/update', {
              ...values,
              id: this.paperId ? this.paperId : '',
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.productVisible = false;
              this.getTableData({ page: this.current, pageSize: this.pageSize });
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.productVisible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      console.log('TCL: onConfirm -> record', record);
      let result=await this.$http.post('/paper/setStatus', {id: record.id, status: record.data.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/paper/setStatus', {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success(result.data.msg);
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 查看
    handleChange(record){
      this.detailUrl=record.jump_url;
      this.visibleDetails=true;
    },
    // 取消查看
    onCancelDetail(){
      this.visibleDetails=false;
    },
    // 查看问题列表
    handleLook(record){
      console.log('handleLook -> record', record);
      this.$router.push({path: '/testpaper/list', query: {id: record.id}});
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
  iframe{
    border:none;
  }
  .aim-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    flex-direction: column;
  }
}
</style>
